import {
  PAYMENT_METHOD_MANAGER_ACTIVE,
  PAYMENT_METHOD_MANAGER_ACTIVE_FAIL,
  PAYMENT_METHOD_MANAGER_ACTIVE_RESET,
  PAYMENT_METHOD_MANAGER_ACTIVE_SUCCESS,
  PAYMENT_METHOD_MANAGER_CREATE,
  PAYMENT_METHOD_MANAGER_CREATE_FAIL,
  PAYMENT_METHOD_MANAGER_CREATE_RESET,
  PAYMENT_METHOD_MANAGER_CREATE_SUCCESS,
  PAYMENT_METHOD_MANAGER_DELETE,
  PAYMENT_METHOD_MANAGER_DELETE_FAIL,
  PAYMENT_METHOD_MANAGER_DELETE_RESET,
  PAYMENT_METHOD_MANAGER_DELETE_SUCCESS,
  PAYMENT_METHOD_MANAGER_DETAIL,
  PAYMENT_METHOD_MANAGER_DETAIL_FAIL,
  PAYMENT_METHOD_MANAGER_DETAIL_RESET,
  PAYMENT_METHOD_MANAGER_DETAIL_SUCCESS,
  PAYMENT_METHOD_MANAGER_LIST,
  PAYMENT_METHOD_MANAGER_LIST_COLUMN,
  PAYMENT_METHOD_MANAGER_LIST_FAIL,
  PAYMENT_METHOD_MANAGER_LIST_RESET,
  PAYMENT_METHOD_MANAGER_LIST_SUCCESS,
  PAYMENT_METHOD_MANAGER_ROLE_LIST,
  PAYMENT_METHOD_MANAGER_ROLE_LIST_FAIL,
  PAYMENT_METHOD_MANAGER_ROLE_LIST_RESET,
  PAYMENT_METHOD_MANAGER_ROLE_LIST_SUCCESS,
  PAYMENT_METHOD_MANAGER_UPDATE,
  PAYMENT_METHOD_MANAGER_UPDATE_FAIL,
  PAYMENT_METHOD_MANAGER_UPDATE_RESET,
  PAYMENT_METHOD_MANAGER_UPDATE_SUCCESS,
} from "./actionTypes";

// List PaymentMethodManager
export const listPaymentMethodManager = (params = {}) => ({
  type: PAYMENT_METHOD_MANAGER_LIST,
  payload: { params },
});

export const listPaymentMethodManagerSuccess = data => ({
  type: PAYMENT_METHOD_MANAGER_LIST_SUCCESS,
  payload: data,
});

export const listPaymentMethodManagerFail = error => ({
  type: PAYMENT_METHOD_MANAGER_LIST_FAIL,
  payload: error,
});

export const resetListPaymentMethodManager = () => ({
  type: PAYMENT_METHOD_MANAGER_LIST_RESET,
  payload: {},
});

export const setListPaymentMethodManagerColumn = (field, value) => ({
  type: PAYMENT_METHOD_MANAGER_LIST_COLUMN,
  payload: { field, value },
});

// List PaymentMethodManager Role
export const listPaymentMethodManagerRole = (params = {}) => ({
  type: PAYMENT_METHOD_MANAGER_ROLE_LIST,
  payload: { params },
});

export const listPaymentMethodManagerRoleSuccess = data => ({
  type: PAYMENT_METHOD_MANAGER_ROLE_LIST_SUCCESS,
  payload: data,
});

export const listPaymentMethodManagerRoleFail = error => ({
  type: PAYMENT_METHOD_MANAGER_ROLE_LIST_FAIL,
  payload: error,
});

export const resetListPaymentMethodManagerRole = () => ({
  type: PAYMENT_METHOD_MANAGER_ROLE_LIST_RESET,
  payload: {},
});

// Create PaymentMethodManager
export const createPaymentMethodManager = userCreate => ({
  type: PAYMENT_METHOD_MANAGER_CREATE,
  payload: { userCreate },
});

export const createPaymentMethodManagerSuccess = data => ({
  type: PAYMENT_METHOD_MANAGER_CREATE_SUCCESS,
  payload: data,
});

export const createPaymentMethodManagerFail = error => ({
  type: PAYMENT_METHOD_MANAGER_CREATE_FAIL,
  payload: error,
});

export const resetCreatePaymentMethodManager = () => ({
  type: PAYMENT_METHOD_MANAGER_CREATE_RESET,
  payload: {},
});

// Detail PaymentMethodManager
export const detailPaymentMethodManager = (userId, params = {}) => ({
  type: PAYMENT_METHOD_MANAGER_DETAIL,
  payload: { userId, params },
});

export const detailPaymentMethodManagerSuccess = data => ({
  type: PAYMENT_METHOD_MANAGER_DETAIL_SUCCESS,
  payload: data,
});

export const detailPaymentMethodManagerFail = error => ({
  type: PAYMENT_METHOD_MANAGER_DETAIL_FAIL,
  payload: error,
});

export const resetDetailPaymentMethodManager = () => ({
  type: PAYMENT_METHOD_MANAGER_DETAIL_RESET,
  payload: {},
});

// Update PaymentMethodManager
export const updatePaymentMethodManager = (userId, data = {}) => ({
  type: PAYMENT_METHOD_MANAGER_UPDATE,
  payload: { userId, data },
});

export const updatePaymentMethodManagerSuccess = data => ({
  type: PAYMENT_METHOD_MANAGER_UPDATE_SUCCESS,
  payload: data,
});

export const updatePaymentMethodManagerFail = error => ({
  type: PAYMENT_METHOD_MANAGER_UPDATE_FAIL,
  payload: error,
});

export const resetUpdatePaymentMethodManager = () => ({
  type: PAYMENT_METHOD_MANAGER_UPDATE_RESET,
  payload: {},
});

// Delete PaymentMethodManager
export const deletePaymentMethodManager = userId => ({
  type: PAYMENT_METHOD_MANAGER_DELETE,
  payload: { userId },
});

export const deletePaymentMethodManagerSuccess = data => ({
  type: PAYMENT_METHOD_MANAGER_DELETE_SUCCESS,
  payload: data,
});

export const deletePaymentMethodManagerFail = error => ({
  type: PAYMENT_METHOD_MANAGER_DELETE_FAIL,
  payload: error,
});

export const resetDeletePaymentMethodManager = () => ({
  type: PAYMENT_METHOD_MANAGER_DELETE_RESET,
  payload: {},
});

// Active PaymentMethodManager
export const activePaymentMethodManager = (userId, data = {}) => ({
  type: PAYMENT_METHOD_MANAGER_ACTIVE,
  payload: { userId, data },
});

export const activePaymentMethodManagerSuccess = data => ({
  type: PAYMENT_METHOD_MANAGER_ACTIVE_SUCCESS,
  payload: data,
});

export const activePaymentMethodManagerFail = error => ({
  type: PAYMENT_METHOD_MANAGER_ACTIVE_FAIL,
  payload: error,
});

export const resetActivePaymentMethodManager = () => ({
  type: PAYMENT_METHOD_MANAGER_ACTIVE_RESET,
  payload: {},
});
